import { render, staticRenderFns } from "./UsersDeleteConfirm.vue?vue&type=template&id=2e982733&"
import script from "./UsersDeleteConfirm.vue?vue&type=script&lang=js&"
export * from "./UsersDeleteConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports